"use client";

import Button from '@/components/button';
import styles from './_hcp-subnav-tabs.module.scss';
import { useEffect, useState } from 'react';
import { renderToString } from 'react-dom/server';

export default function HcpSubnavTabs({ subnavItems, setSubnavIndex = undefined, subnavIndex = undefined }) {
  const [currentTabIndex, setCurrentTabIndex] = useState(0);

  function handleClick(e) {
    const i = e.currentTarget.dataset.index;

    if (i !== undefined && i !== null) {
      setCurrentTabIndex(parseInt(i));

      if (setSubnavIndex !== undefined) {
        setSubnavIndex(parseInt(i));
      }
    }
  }

  useEffect(() => {
    if (subnavIndex !== undefined) {
      setCurrentTabIndex(subnavIndex);
      
      if (setSubnavIndex !== undefined) {
        setSubnavIndex(subnavIndex);
      }
    } 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subnavIndex]);

  return (
    <div className={styles.container}>
      <div className="container container--px-0">
        <ul className={styles.tabs}>
          {subnavItems?.map((tab, i) => (
            <li key={`tab_key_${i}`}>
              <Button
                type="button"
                customClass={i === currentTabIndex ? styles.active : ''}
                data-index={i}
                onClick={handleClick}
                data-gtm-event-category="Action"
                data-gtm-event-action="Click"
                data-gtm-event-label={`${renderToString(tab)} Tab`}
              >
                <span>
                  {tab}
                </span>
              </Button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}